import { useEffect, useState } from "react"
import { Disposition } from "../Models/disposition"
import { startForm } from "../Utils/botUtils"
import { changeGender, changeVoice } from "../Utils/configurationUtils"
import { RetorikConfiguration } from "./Bot/data"
import { useAjadi } from "./Context/AjadiContext"


const DispositionHandler = () : JSX.Element => {
    const Ajadi = useAjadi()
    const [showTestMenu, setShowTestMenu] = useState<boolean>(false);

    useEffect(()=>{
        console.log("CHANGE DISPOSITION")
        switch (Ajadi.disposition) {
            case Disposition.Base:
                    ChangeDisposition(Disposition.Base);
                break;
            case Disposition.JeuxRoleFemme:
                    ChangeDisposition(Disposition.JeuxRoleFemme);
                break;
            case Disposition.JeuxRoleHomme:
                    ChangeDisposition(Disposition.JeuxRoleHomme);
                break;
            default:
                break;
        }
    }, [Ajadi.disposition])

    useEffect(()=>{
        if(Ajadi.userInfo){
            if(Ajadi.userInfo.gender === "male"){
                Ajadi.setDisposition(Disposition.JeuxRoleHomme)
            }
            else{
                Ajadi.setDisposition(Disposition.JeuxRoleFemme)
            }
        }
        else{
            Ajadi.setDisposition(Disposition.Base)
        }
    }, [Ajadi.userInfo])

    const ChangeDisposition = (disp : Disposition) =>{
        console.log(`Change disposition : ${disp}`);
        //Get all element to modify 
        let container = document.getElementById("retorik-container");
        let botResponseElement = document.getElementById("retorik-botResponse");
        let config : RetorikConfiguration = Ajadi.retorikConfig;
    
        if(disp === Disposition.Base){
            
            config = changeGender("female", config);
            config = changeVoice("female", "DeniseNeural", config);
            //UpdateClassOnVideoEnd("patiente", false, Disposition.Base);
        }
        if(disp === Disposition.JeuxRoleFemme){
            
            config = changeGender("female", config);
            config = changeVoice("female", "CoralieNeural", config);
            //UpdateClassOnVideoEnd("patiente", false, Disposition.JeuxRoleFemme);
        }
        if(disp === Disposition.JeuxRoleHomme){
            
            config = changeGender("female", config);
            config = changeVoice("male", "HenriNeural", config);
            //UpdateClassOnVideoEnd("patiente", false, Disposition.JeuxRoleHomme);
        }

        console.log("Set Config",config)
        Ajadi.setRetorikConfig(config);
    }

    const UpdateClassOnVideoEnd = (className : string, add : boolean, disp : Disposition) =>{
        let loaded = 0;
        let ended = 0;
        let show = true;
        document.querySelectorAll("#retorik-animation video").forEach(
            (video ) => {
                let videoElement = video as HTMLMediaElement;
                (videoElement as HTMLMediaElement).onloadeddata = (ev : Event)=> {
                    console.log("onloadeddata", ev?.target)
                    var div = document.querySelector("#retorik-animation");
                    if(div){
                        (div as HTMLElement).style.display = "none";
                    }
                    loaded++;
                    if(loaded == 4){
                        console.log("all video loaded")
                        show = false;
                        if(div){
                            if(add){
                                div.classList.add(className);
                            }
                            else{
                                div.classList.remove(className);
                            }
                            (div as HTMLElement).style.display = "";
                        } 
                        loaded = 0;
                        document.querySelectorAll("#retorik-animation video").forEach(
                            (video) => {
                                let videoElement = video as HTMLMediaElement;
                                videoElement.onloadeddata = null;
                            }
                        );
                    }
                }
            }
        )
    }

    const changeDispositionButtonHandle = () =>{
        let animation = prompt("Entrer la disposition voulue");
        switch (animation) {
            case "base":
              Ajadi.setDisposition(Disposition.Base);
              break;
            case "male":
              Ajadi.setDisposition(Disposition.JeuxRoleHomme);
              break;
            case "female":
              Ajadi.setDisposition(Disposition.JeuxRoleFemme);
              break;
            
            default:
              break;
          }
    }

    return (<>
        {
            showTestMenu &&
                <ul className="testButtons">
                    <li><button onClick={() => startForm("Présentation de Vicky")}>Présentation de Vicky</button></li>
                    <li><button onClick={() => startForm("Description de la situation")}>Description de la situation</button></li>
                    <li><button onClick={() => startForm("Description de l’émotion")}>Description de l’émotion</button></li>
                    <li><button onClick={() => startForm("Méthodologie")}>Méthodologie</button></li>
                    <li><button onClick={() => startForm("Simulation jeu de rôle")}>Simulation jeu de rôle</button></li>
                    <li><button onClick={() => changeDispositionButtonHandle()}>Changement de disposition</button></li>
                    <li><button onClick={() => document.location.href="/"}>Retour à l'accueil</button></li>
                </ul>
        }
        </>
        )
}

export default DispositionHandler